/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigRightDash = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M5 9v6" }],
    ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z" }]
  ]
];

export { ArrowBigRightDash as default };
//# sourceMappingURL=arrow-big-right-dash.js.map
